import React from 'react';
import { ActionContainer, ActionLink, ActionTitle } from '../../shared/styles';
import FundsContext from './context';

export default function Actions() {
  const { dispatch } = React.useContext(FundsContext);

  const showImportModal = e => {
    e && e.preventDefault();

    dispatch({ type: 'importFund' });
  };
  return (
    <ActionContainer>
      <ActionTitle>Tools</ActionTitle>
      <ActionLink href="/lwadmin/fund/new">Create Fund</ActionLink>
      <ActionLink href="#" onClick={showImportModal}>Create Fund - Import</ActionLink>
      <ActionLink href="/lwadmin/funds/questions">Manage Q&A Questions</ActionLink>
      <ActionLink href="/lwadmin/data_provider/fund_categories">Manage Categories</ActionLink>
    </ActionContainer>
  );
}
